import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup } from '@angular/forms';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { BaseAppEditComponent } from '../../base-components/base-app-edit.component';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { InventoryService } from '../../services/inventory.service';
import { LabelPrintQueueBus } from '../../models/LabelPrintQueueBus';
import { CommonValues } from '../../static/CommonValues';
import { BaseMessageInfo } from '../../models/BaseMessageInfo';
import { GItem } from '../../models/GItem';
import { DistributedPrintingService } from '../../services/distributed-printing.service';
import { ZebraPrinterStatusDto } from '../../models/ZebraPrinterStatusDto';
import { ZebraPrintRequestDto } from '../../models/ZebraPrintRequestDto';
import { ZebraPrinterTemplateDto } from '../../models/ZebraPrinterTemplateDto';
import { FeatureFlagService } from '../../services/feature-flag.service';

@Component({
    selector: 'dymo-etc-print',
    templateUrl: './dymo-etc-print.component.html',
    styleUrls: ['./dymo-etc-print.component.scss']
})
export class DymoEtcPrintComponent extends BaseAppEditComponent<LabelPrintQueueBus, InventoryService>  {

    constructor(globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, svc_data: InventoryService, private svc_zebra: DistributedPrintingService, private featureFlagService: FeatureFlagService) {
        super(globals, qry_rd);
        this.svc_data = svc_data;
        this.svc_zebra = svc_zebra;
        this.className = "LabelPrintQueueBus";
        this.saveMode = SaveMode.individual;
        this.appCode = "Label Print Queue";
        let x = CommonValues.LabelTypes_DispatchParts;
    }
    appCode: string = null;
    subs_zebraPrinters: Subscription;
    subs_zebraTemplates: Subscription;
    availableZebraPrinters: ZebraPrinterStatusDto[];
    availableZebraTemplates: ZebraPrinterTemplateDto[];
    labelTypes: GItem[];
    labelTemplates: GItem[];
    public selectedZebraPrinter: string = '';
    public selectedZebraTemplate: string = '';
    private subs_featureFlagSet: Subscription; //place as class variable
    featureFlagSet = {};

    ngOnInit() {
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.getLabelPrintQueueReferenceData().subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.labelTypes = info.dcValues.labelTypes;
                this.labelTemplates = info.dcValues.labelTemplates;
                //TODO: [dturco 02.18.2025] when setup no longer uses feature flags remove this
                this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
                    this.featureFlagSet = data;
                    this.setup();
                });
            }
        });
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_featureFlagSet); //place in ngOnDestroy
    }
    get hasLocalReferenceData(): boolean {
        return CommonFunctions.hasArrayElementValue(this.labelTemplates);
    }
    protected _referenceIdType: number; //1-Dispatch Parts, 2-Parts, 3-Vehicle
    @Input() referenceId: any;
    @Input() set referenceIdType(value: number) {
        if (CommonFunctions.hasNumberValue(value)) {
            this._referenceIdType = value;
            if (this.hasLocalReferenceData) {
                this.setup();
            }
        }
        else {

        }

    }

    get hasReferenceId(): boolean {
        return CommonFunctions.hasGuidValue(this.referenceId);
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
        });

    }
    setForm() {
        this.editForm.patchValue({
        });
    }
    setup() {
        this.printOptions = [];
        if (CommonFunctions.hasValue(this._referenceIdType)) {
            //Zebra Printer Dialog
            if (this.featureFlagSet['distributed-printing-for-zebra']) {
                if (this._referenceIdType == 1) {
                    this.labelTemplates.push(new GItem({
                        description: "Zebra Print",
                        value: "ZebraPrint",
                        category: CommonValues.LabelTypes_DispatchParts,
                        canSelect: true,
                        reference: null
                    }));
                }

            }
            //dymo printers
            if (this._referenceIdType == 1) {
                var items = this.labelTemplates.filter(s => s.category === CommonValues.LabelTypes_DispatchParts || s.category === CommonValues.LabelTypes_DispatchPartsWithOverflow);
            }
            else if (this._referenceIdType == 2) {
                var items = this.labelTemplates.filter(s => s.category === CommonValues.LabelTypes_PartBarcode);
            }
            else if (this._referenceIdType == 3) {
                var items = this.labelTemplates.filter(s => s.category === CommonValues.LabelTypes_VehicleId);
            }
            for (let i = 0; i < items.length; i++) {
                this.printOptions.push(items[i].description.trim());
            }
        }

    }
    dymoEtcPrint(labelTemplate: GItem) {
        let busObj: LabelPrintQueueBus = new LabelPrintQueueBus(null);
        busObj.referenceId = this.referenceId;
        busObj.labelTemplateId = labelTemplate.value;
        busObj.labelTypeId = labelTemplate.category;
        busObj.referenceIdType = this._referenceIdType;
        busObj.status = 1;
        this.svc_data.saveLabelPrintQueueItem(busObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.saveSuccess();
            }
        });
    }

    public printOptions: Array<any> = [
    ];
    public iconClass = 'fas fa-print';
    onPrintClick(e: string) {
        let index = this.printOptions.indexOf(e);
        var mItem = this.labelTemplates.find(s => s.description === e);
        if (this.featureFlagSet['distributed-printing-for-zebra'] && mItem.value === 'ZebraPrint') {
            //alert('you selected zebra!');
            this.toggleZebraPrinterDialog();
        } else {
            this.dymoEtcPrint(mItem);
        }
    }

    showDialog: boolean = false;
    toggleZebraPrinterDialog() {
        this.dataLoading = true;
        this.subs_zebraPrinters = this.svc_zebra.getPrinterStatuses(false).subscribe(data => {
            if (data && data.success) {
                let arr: ZebraPrinterStatusDto[] = [];
                for (let i = 0; i < data.resultList.length; i++) {
                    arr.push(new ZebraPrinterStatusDto(data.resultList[i]));
                }
                this.availableZebraPrinters = arr;

                console.log(JSON.stringify(data.resultList));
                //this.dataLoading = false;
                this.subs_zebraTemplates = this.svc_zebra.getPrinterTemplates(false).subscribe(data => {
                    if (data && data.success) {
                        let arr2: ZebraPrinterTemplateDto[] = [];
                        for (let i = 0; i < data.resultList.length; i++) {
                            arr2.push(new ZebraPrinterTemplateDto(data.resultList[i]));
                        }
                        this.availableZebraTemplates = arr2;

                        console.log(JSON.stringify(data.resultList));
                        this.dataLoading = false;
                        this.showDialog = !this.showDialog;
                    } else if (!data.success) {
                        this.dataLoading = false;
                    }
                });
                //this.showDialog = !this.showDialog;
            } else if (!data.success) {
                this.dataLoading = false;
            }
        });
    }

    printToZebra() {
        console.log('printToZebra clicked!');
        let debug = true;
        this.showDialog = !this.showDialog;
        let notificationMessage: string = '';
        let type: string = '';

        let printRequest = new ZebraPrintRequestDto();
        printRequest.zebraPrinterId = this.selectedZebraPrinter;
        printRequest.requestDateTime = new Date(Date.now());
        printRequest.zebraTemplateId = this.selectedZebraTemplate;
        printRequest.contentSource = this.referenceId;

        this.subs_zebraPrinters = this.svc_zebra.printRequest(printRequest).subscribe(data => {
            if (data && data.success) {
                console.log("Print Request Result", data.result);
                notificationMessage = 'Print Successfully sent to ' + this.availableZebraPrinters.find(s => s.zebraPrinterId == this.selectedZebraPrinter).printerDisplayName + '!  It may take up to 60 seconds to print.';
                this.globals.notifySuccess(notificationMessage, false);
            } else if (!data.success) {
                notificationMessage = 'Print failed to send to ' + this.availableZebraPrinters.find(s => s.zebraPrinterId == this.selectedZebraPrinter).printerDisplayName + '!';
                this.globals.notifyError(notificationMessage, true);
            }
        });

    }
}
